import { render, staticRenderFns } from "./loading_image.vue?vue&type=template&id=2ce8a7f8&scoped=true"
import script from "./loading_image.vue?vue&type=script&lang=js"
export * from "./loading_image.vue?vue&type=script&lang=js"
import style0 from "./loading_image.vue?vue&type=style&index=0&id=2ce8a7f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8a7f8",
  null
  
)

export default component.exports